/**
 * Компонент Swiper слайдера для секции «Топ авторов».
 */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class TopAuthorsSwiper {
    /**
     * Инициализирует слайдер, если секция есть на странице.
     */
    constructor() {
        const swiperEl = document.querySelector('.section-home-top-authors__swiper');

        if (!swiperEl) {
            return;
        }

        return new Swiper(swiperEl, this.getDefaultConfig());
    }

    /**
     * @returns {Object}
     */
    getDefaultConfig() {
        return {
            modules: [Navigation],
            slidesPerView: 1.1,
            spaceBetween: 8,
            loop: true,
            navigation: {
                nextEl: '.section-home-top-authors__swiper-button-next',
                prevEl: '.section-home-top-authors__swiper-button-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 2.5,
                },
            },
        };
    }
}

export default TopAuthorsSwiper;
